export class GetAzureQueryExportStorage200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageAccountName",
            "baseName": "storageAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "containers",
            "baseName": "containers",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetAzureQueryExportStorage200Response.attributeTypeMap;
    }
    constructor() {
    }
}
